import React from 'react';
import { useDeviceType } from '../../hooks/useDeviceType';
import DesktopList from './DesktopList';
import MobileList from './MobileList';
import CompactList from './CompactList'; // Nuevo componente para resoluciones medias

/**
 * Lista adaptativa inteligente que maneja múltiples resoluciones:
 * - mobile: Cards verticales (≤768px)  
 * - tablet/desktop-small: Tabla compacta (769px-1440px)
 * - desktop-large: Tabla completa (>1440px)
 */
export default function SmartAdaptiveList({ 
  items = [], 
  onItemClick, 
  // Props para vista desktop
  renderDesktopRow, 
  headers = [],
  // Props para vista mobile
  renderMobileCard,
  // Props para vista compacta 
  renderCompactRow,
  compactHeaders = [],
  // Props compartidas
  emptyMessage = "No hay elementos para mostrar",
  className = "" 
}) {
  const deviceType = useDeviceType();

  if (deviceType === 'mobile') {
    // Solo móviles reales usan las tarjetas
    return (
      <MobileList
        items={items}
        onItemClick={onItemClick}
        renderMobileCard={renderMobileCard}
        emptyMessage={emptyMessage}
        className={className}
      />
    );
  } else {
    // TODAS las resoluciones de PC usan la misma vista completa
    return (
      <DesktopList
        items={items}
        onItemClick={onItemClick}
        renderRow={renderDesktopRow}
        headers={headers}
        emptyMessage={emptyMessage}
        className={className}
      />
    );
  }
}